module.exports = __webpack_public_path__ + "static/Performance_individual_hires-0cca340ab9e9ddc67af7711597806ff1.jpg";